import { connectStorageEmulator, deleteObject, getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import APP from './app';
import { EMULATOR_CONFIG, USE_EMULATOR } from './config';

const STORAGE = getStorage(APP);

if (USE_EMULATOR) {
  connectStorageEmulator(STORAGE, EMULATOR_CONFIG.STORAGE.host, EMULATOR_CONFIG.STORAGE.port);
}

/**
 * File upload to storage
 * @param {File} file - Upload file
 * @param {string} filePath - Storage path
 * @returns {Promise<string>} - File path
 */
export const sendFileToStorage = async (file, filePath) => {
  const storageRef = ref(STORAGE, filePath);
  const result = await uploadBytes(storageRef, file);
  return result.metadata.fullPath;
};

/**
 * Get file from storage
 * @param {string} filePath - File path (must be non-empty; root reference is invalid)
 * @returns {Promise<string>} - Download URL
 */
export const getFromStorage = async filePath => {
  const path = (filePath || '').trim();
  if (!path) {
    throw new Error('getFromStorage requires a non-empty path');
  }
  const storageRef = ref(STORAGE, path);
  const url = await getDownloadURL(storageRef);
  return url;
};

/**
 * Delete object by path
 * @param {string} path - Path
 * @returns {Promise<void>}
 */
export const deleteObjectByPath = async path => {
  const fileRef = ref(STORAGE, path);
  await deleteObject(fileRef);
};

export default STORAGE;
